import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { MessageService } from 'primeng/api'

@Component({
  selector: 'basin-formly-file-upload',
  templateUrl: './formly-file-upload.component.html',
  styleUrls: ['./formly-file-upload.component.scss'],
  providers: [MessageService],
})
export class FormlyFileUploadComponent extends FieldType {
  uploadedFiles: any[] = []

  constructor(private messageService: MessageService) {
    super()
  }

  onBasicUploadAuto(event, fileUpload) {
    for (const file of event.files) {
      this.uploadedFiles.push(file)
    }
    this.field.model.files = this.uploadedFiles
    fileUpload.clear()
    this.messageService.add({
      severity: 'info',
      summary: 'Success',
      detail: 'File Uploaded',
    })
  }

  deleteFile(index: number) {
    this.uploadedFiles.splice(index, 1)
  }
}
